import { SeuRoute, SeuRouteKey } from '@seu-types';

export const SEU_ROUTES: { [key in SeuRouteKey]: SeuRoute } = {
  home: { slug: '', path: [] },
  offers: { slug: 'offers', path: ['offers'] },
  'offer-detail': { slug: 'offers/:id', path: ['offers', ':id'] },
};
